module.exports = __webpack_public_path__ + "img/block_search.01bc3dfd.png";